import React from "react";
import { EditableInfo } from "@icoach/components";
import { isEqual } from "@util/utils";
import { PUSH_STATUS_TYPE } from "@icoach/constants/";

const SalesPushBox = ({ className, label, sourceData, onEdit }) => {
	const { pushStatusText = "", reasonTypeText = "", pushStatus } = sourceData || {};

	const canEdit = isEqual(pushStatus, PUSH_STATUS_TYPE.NOSUBSCRIBE) || isEqual(pushStatus, PUSH_STATUS_TYPE.DONOTPUSH);

	return (
		<EditableInfo label={label} onEdit={canEdit ? onEdit : null} className={className}>
			{reasonTypeText ? `${pushStatusText}(${reasonTypeText})` : pushStatusText}
		</EditableInfo>
	);
};

export default SalesPushBox;
